<template>
  <div v-bind:class="mapStyle">
    <ul class="flow_ul">
      <li v-for="(page,index) in pageList" :key="'flow-' + index" :value="page.id"
          v-bind:style="{left: (-20 * index) + 'px'}"
          v-bind:class="{selected: (page.key == pageKey)}">
        <!-- <div class="pageTitle" @click="route(page.route, page.params)"><a>{{page.title}}</a></div>
        <div v-if="index !== (pageList.length - 1)" class="arrow">&gt;</div> -->
        <div class="circle_set">
          <div v-bind:class="{circle_number: true, circle_number_selected: (page.key == pageKey)}">{{index + 1}}</div>
          <div>{{page.title}}</div>
        </div>
        <div v-if="index !== (pageList.length - 1)" class="catch"></div>
        <!-- <div class="flow_arrow"></div> -->
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'addNewUserModal',
  components: {
  },
  props: {
    pageKey: String,
    pageList: Array,
    mapStyle: {
      default: 'arrow_flow',
      type: String
    }
  },
  data () {
    return {
    }
  },
  methods: {
    route: function (name, params) {
      if (!name) return
      this.$router.push({
        name: name,
        query: params
      })
    }
  }
}
</script>
<style src="../../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/components/common/Flow.vue